<template>
    <el-dialog v-dialogDrag class="dialog" width="1080px" :visible.sync="dialogVisible" v-loading="dialoading"
               :close-on-click-modal="false"
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                编辑销售员商品成本信息
            </div>
        </div>
        <div class="dialog_body">
            <el-form :inline="true" :model="form" ref="formData" v-loading="loading"
                     label-width="120px">
                <div>
                    <el-form-item label="仓库名称">
                        <el-input style="width:200px" v-model="form.warehouseName" placeholder="仓库名称" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="供应商">
                        <el-input style="width:200px" v-model="form.supplierName" placeholder="供应商" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="物资类别">
                        <el-input style="width:200px" v-model="form.typeName" placeholder="物资类别" readonly></el-input>
                    </el-form-item>
                </div>

                <div>
                    <el-form-item label="物资名称" >
                        <el-input style="width:200px" v-model="form.proName" placeholder="选择库存信息" readonly >
                            <el-button slot="append" icon="el-icon-plus" @click.native="clickKc"></el-button> </el-input>
                    </el-form-item>
                    <el-form-item label="物资编码">
                        <el-input style="width:200px" v-model="form.proCode" placeholder="物资编码" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="计量单位">
                        <el-input style="width:200px" v-model="form.units" placeholder="计量单位"  readonly></el-input>
                    </el-form-item>
                </div>

                <div>
                    <el-form-item label="规格型号">
                        <el-input style="width:200px" v-model="form.specification" placeholder="规格型号"  readonly></el-input>
                    </el-form-item>
                    <el-form-item label="产地">
                        <el-input style="width:200px" v-model="form.origin" placeholder="产地" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="颜色">
                        <el-input style="width:200px" v-model="form.color" placeholder="颜色" readonly></el-input>
                    </el-form-item>
                </div>

                <div>
                    <el-form-item label="有效期">
                        <el-input style="width:200px" v-model="form.planPrice01" placeholder="有效期" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="批次">
                        <el-input style="width:200px" v-model="form.planPrice02" placeholder="批次" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="生产厂家/品牌">
                        <el-input style="width:200px" v-model="form.planPrice03" placeholder="生产厂家/品牌" readonly></el-input>
                    </el-form-item>
                </div>

                <div>
                    <el-form-item label="库存数量">
                        <el-input style="width:200px" v-model="form.endNum" placeholder="库存数量" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="库存单价">
                        <el-input style="width:200px" v-model="form.endPrice" placeholder="库存单价" readonly></el-input>
                    </el-form-item>
                    <el-form-item label="库存小计">
                        <el-input style="width:200px" v-model="form.endTotal" placeholder="库存小计" readonly></el-input>
                    </el-form-item>
                </div>

                <div>
                    <el-form-item label="业务员">
                        <el-input style="width:200px" v-model="form.salesMan" placeholder="业务员" @click.native="clickStaff"></el-input>
                    </el-form-item>
                    <el-form-item label="销售成本">
                        <el-input style="width:200px" v-model="form.costPrice" placeholder="销售成本"></el-input>
                    </el-form-item>
                </div>

                <div>
                    <el-form-item label="备注" class="bzClass">
                        <el-input
                                style="width: 860px"
                                resize="none"
                                type="textarea"
                                placeholder="备注"
                                v-model="form.remark"
                                rows="2"
                                show-word-limit>
                        </el-input>
                    </el-form-item>
                </div>

            </el-form>
            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>

            <selStaff v-if="showStaff"
                      :staffId="staffId"
                      @closeDialog="closeDialog"
                      @checkRow="checkStaff">
            </selStaff>
            <selKcSingle v-if="showKc"
                      :proInvenDid="proInvenDid"
                      @closeDialog="closeDialog"
                      @checkRow="checkKc">
            </selKcSingle>
        </div>

    </el-dialog>

</template>

<script>
    import selStaff from '@/components/rszy/staff/selStaff'
    import selKcSingle from '@/components/page/wzgl/wzgl/selKcSingle'

    export default {
        name: "editDialog",
        props: ['formData', 'loading'],
        components: {selStaff,selKcSingle},
        data() {
            return {
                showStaff:false,
                showKc:false,
                proInvenDid:"",
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px',
            };
        },
        methods: {
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            async submitForm() {
                if(this.form.proName==null){
                    this.$message({message: '请选择库存信息', type: 'error'});
                    return false;
                }
                if(this.form.salesMan==null || this.form.salesMan==''){
                    this.$message({message: '请选择业务员', type: 'error'});
                    return false;
                }
                if(this.form.costPrice==null){
                    this.$message({message: '请设置销售成本', type: 'error'});
                    return false;
                }
                this.$emit('submitForm', this.form)
            },

            closeDialog() {
                this.showStaff = false;
                this.showKc = false;
            },
            clickStaff() {
                this.staffId = this.form.staffId;
                this.showStaff = true;
            },
            checkStaff(row) {
                this.form.staffId = row.staffId;
                this.form.salesMan = row.staffName;
                this.showStaff = false;
            },
            clickKc() {
                this.proInvenDid = this.form.proInvenDid;
                console.log(this.proInvenDid)
                this.showKc = true;
            },
            checkKc(row) {
                this.form.proInvenDid = row.proInvenDid;
                this.form.warehouseNo = row.warehouseNo;
                this.form.warehouseName = row.warehouseName;
                this.form.typeName = row.typeName;
                this.form.proName = row.proName;
                this.form.proCode = row.proCode;
                this.form.units = row.units;
                this.form.specification = row.specification;
                this.form.origin = row.origin;
                this.form.color = row.color;
                this.form.manufacturer = row.manufacturer;
                this.form.productDate = row.productDate;
                this.form.batch = row.batch;
                this.form.validityDate = row.validityDate;
                this.form.supplierName = row.supplierName;
                this.form.endNum = row.endNum;
                this.form.endPrice = row.endPrice;
                this.form.endTotal = row.endTotal;
                this.showKc = false;
            },
        }
    }
</script>

